import React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import AreaTitle from '../../../components/areaTitle/AreaTitle';
import LogSummaryCards from './components/LogSummaryCards';
import LogsTable from './components/LogsTable';
import TopErrorsList from './components/TopErrorsList';
import PhpLogTail from './components/PhpLogTail';
import useAdminLogs from './hooks/useAdminLogs';

/**
 * AdminLogs - Leitura dos logs unificados da plataforma (Admin Geral)
 *
 * Responsabilidades:
 * - Consome useAdminLogs() para dias disponíveis, resumo do dia selecionado (digest),
 *   lista paginada/filtrada e auto-refresh (quando o dia selecionado é hoje)
 * - Renderiza AreaTitle + cards de resumo + tabela filtrável (com erros mais frequentes
 *   ao lado) + tail colapsado do php.log
 * - Todos os filtros vivem na URL (useSearchParams), então o link pode ser compartilhado
 */
function AdminLogs() {
  const {
    date,
    setDate,
    dayOptions,
    channels,
    levels,
    isToday,
    daysError,

    summary,
    summaryError,

    logs,
    logsLoading,
    logsError,
    pagination,
    setPage,

    channel,
    setChannel,
    level,
    setLevel,
    companyInput,
    setCompanyInput,
    reqInput,
    setReqInput,
    searchInput,
    setSearchInput,
    applyReqFilter,
    applyCompanyFilter,
    applyTopErrorFilter,

    autoRefreshPaused,
    toggleAutoRefresh,
  } = useAdminLogs();

  return (
    <Box sx={{ backgroundColor: '#F8F9FC', minHeight: '100vh', p: { xs: 2, md: 3 } }}>
      <Box sx={{ mb: 3 }}>
        <AreaTitle
          Title="Admin Geral · Logs"
          Icon={<ArticleOutlinedIcon />}
          Description="Investigue eventos, erros e avisos registrados pela plataforma, por dia e canal."
        />
      </Box>

      {daysError && (
        <Alert severity="error" sx={{ mb: 2 }}>{daysError}</Alert>
      )}
      {summaryError && (
        <Alert severity="error" sx={{ mb: 2 }}>{summaryError}</Alert>
      )}

      <LogSummaryCards summary={summary} />

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <Box sx={{ flex: '3 1 640px', minWidth: 0 }}>
          <LogsTable
            logs={logs}
            isLoading={logsLoading}
            error={logsError}
            pagination={pagination}
            date={date}
            onPageChange={setPage}
            onFilterReq={applyReqFilter}
            onFilterCompany={applyCompanyFilter}
            filters={{
              dayOptions,
              date,
              onDateChange: setDate,
              channels,
              channel,
              onChannelChange: setChannel,
              levels,
              level,
              onLevelChange: setLevel,
              companyInput,
              onCompanyInputChange: setCompanyInput,
              reqInput,
              onReqInputChange: setReqInput,
              searchInput,
              onSearchInputChange: setSearchInput,
              isToday,
              autoRefreshPaused,
              onToggleAutoRefresh: toggleAutoRefresh,
            }}
          />
        </Box>

        <Box sx={{ flex: '1 1 300px', minWidth: 280, maxWidth: 380 }}>
          <TopErrorsList topErrors={summary?.top_errors} onSelect={applyTopErrorFilter} />
        </Box>
      </Box>

      <PhpLogTail date={date} />
    </Box>
  );
}

export default AdminLogs;
